export const polarisSchema = {
    type: "object",
    properties: {
        Gen: {
            type: "object",
            properties: {
                ConfigId: {
                    type: "integer",
                    minimum: 0,
                },
            },
            required: ["ConfigId"],
        },
        Fota: {
            type: "object",
            properties: {
                AppVer: {
                    type: "string",
                },
            },
            required: ["AppVer"],
        },
        IOT: {
            type: "object",
            properties: {
                RptPerHour: {
                    type: "integer",
                    minimum: 1,
                    maximum: 30,
                },
                RptGps: {
                    type: "boolean",
                    default: false,
                },
            },
            required: ["RptPerHour", "RptGps"],
        },
    },
    required: ["Gen", "IOT", "Fota"],
};
